class Counter {
  constructor(counterContainer) {
    this.counterContainer = document.querySelector(counterContainer);
  }

  init() {
    if (this.counterContainer) {
      this.counterIncrease = this.counterContainer.querySelector('.js-increase');
      this.counterDecrease = this.counterContainer.querySelector('.js-decrease');
      this.counterInput = this.counterContainer.querySelector('input[type="number"]');

      this.counterIncrease.addEventListener('click', (e) => {
        e.preventDefault();

        let valueCurrentIncrease = this.counterInput;
        let newNumberFieldValue = (parseInt(valueCurrentIncrease.value) + 1);

        valueCurrentIncrease.value = newNumberFieldValue;
      });

      this.counterDecrease.addEventListener('click', (e) => {
        e.preventDefault();
        let valueCurrentDecrease = this.counterInput;
        let newNumberFieldValue = (parseInt(valueCurrentDecrease.value) - 1);

        newNumberFieldValue = newNumberFieldValue < 0 ? 0 : newNumberFieldValue;
        valueCurrentDecrease.value = newNumberFieldValue;
      })
    }
  }
}

class CounterCart {
  constructor(counterContainer, updateCartButton) {
    this.counterContainer = document.querySelectorAll(counterContainer);
    this.updateCartButton = document.querySelector(updateCartButton);
  }

  init() {
    if (this.counterContainer) {

      this.counterContainer.forEach(counterEl => {
        this.counterIncrease = counterEl.querySelectorAll('.js-increase-cart');
        this.counterDecrease = counterEl.querySelectorAll('.js-decrease-cart');


        this.counterIncrease.forEach(counterIncreaseEl => {
          counterIncreaseEl.addEventListener('click', (e) => {

            e.preventDefault();

            let valueCurrentIncrease = counterIncreaseEl.parentElement.querySelector('.qty');

            let newNumberFieldValue = (parseInt(valueCurrentIncrease.value) + 1);

            this.triggerChangeEvent(valueCurrentIncrease, newNumberFieldValue);
          });
        });

        this.counterDecrease.forEach(counterDecreaseEl => {
          counterDecreaseEl.addEventListener('click', (e) => {
            e.preventDefault();

            let valueCurrentDecrease = counterDecreaseEl.parentElement.querySelector('.qty');

            let newNumberFieldValue = (parseInt(valueCurrentDecrease.value) - 1);
            newNumberFieldValue = newNumberFieldValue < 0 ? 0 : newNumberFieldValue;

            this.triggerChangeEvent(valueCurrentDecrease, newNumberFieldValue);
          })
        });
      });
    }
  }

  triggerChangeEvent(el, currentValue) {
    let triggerChangeEvent = document.createEvent('HTMLEvents');
    triggerChangeEvent.initEvent('change', true, false);

    el.addEventListener('change', function (e) {
      e.preventDefault();

      el.value = currentValue;
      el.setAttribute('value', currentValue);

    }, false);

    el.dispatchEvent(triggerChangeEvent);
  }
}


export {Counter, CounterCart};


// WEBPACK FOOTER //
// ./scripts/modules/counter.js